import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .sub-header {
    margin-left: auto;
  }

  .map-wrapper {
    width: 100%;
    height: 282px;
  }

  .map-container {
    width: 100%;
    height: 100%;
    border-radius: 12px;
  }
  
  .widgets-container {
    display: flex;
    justify-content: space-between;
    background-color: ${(props) => props.theme.colors.widget_background};
    border-radius: 12px;
    margin-bottom: 24px;
    overflow: hidden;
  }
`;

export default { Wrapper };
